// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae4910c6","453":"76060bc3","455":"c18b1abb"}[chunkId] + ".chunk.js";
};